import { ApiError } from './api-error';

export class GoneError extends ApiError {}
